import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { useLanguage } from '../../../../../../contexts/LanguageContext';

/**
 * Formu kapatmak için açıklama girişi dialog'u
 */
const CloseDeclarationDialog = ({ 
    visible, 
    onHide, 
    onConfirm, 
    loading = false 
}) => {
    const { t } = useLanguage();
    const [description, setDescription] = useState('');

    useEffect(() => {
        if (!visible) {
            setDescription('');
        }
    }, [visible]);

    const handleConfirm = () => {
        if (description.trim()) {
            onConfirm(description.trim());
        }
    };

    const handleHide = () => {
        if (!loading) {
            setDescription('');
            onHide();
        }
    };

    const renderFooter = () => {
        return (
            <div className="flex justify-content-end gap-2">
                <Button 
                    label={t('common.cancel')}
                    icon="pi pi-times" 
                    outlined 
                    onClick={handleHide} 
                    disabled={loading}
                />
                <Button 
                    label={t('common.confirm')}
                    icon="pi pi-check" 
                    onClick={handleConfirm} 
                    loading={loading}
                    disabled={!description.trim() || loading}
                    severity="warning"
                />
            </div>
        );
    };

    return (
        <Dialog 
            visible={visible} 
            style={{ width: '450px' }} 
            header={t('warranty.customerDeclaration.dialog.closeDeclarationHeader') || 'Formu Kapat'}
            modal 
            className="p-fluid" 
            footer={renderFooter()} 
            onHide={handleHide}
            closable={!loading}
        >
            <div className="field">
                <label htmlFor="closeDescription" className="font-bold block mb-2">
                    {t('warranty.customerDeclaration.dialog.closeDescriptionLabel') || 'Kapatma Açıklaması'} *
                </label>
                <InputTextarea 
                    id="closeDescription" 
                    value={description} 
                    onChange={(e) => setDescription(e.target.value)} 
                    placeholder={t('warranty.customerDeclaration.dialog.closeDescriptionPlaceholder') || 'Formu kapatma nedenini giriniz...'}
                    rows={4}
                    autoResize
                    disabled={loading}
                    autoFocus
                />
                <small className="text-color-secondary">
                    {t('warranty.customerDeclaration.dialog.closeDescriptionHint') || 'Bu alan zorunludur.'}
                </small>
            </div>
        </Dialog>
    );
};

export default CloseDeclarationDialog;
